module.exports = __webpack_public_path__ + "media/backgrounds/video-overlay2-8def739d.png";